var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { attrs: { id: "loaderdash" } }, [
        _c(
          "section",
          { attrs: { id: "logo-loader" } },
          [
            _c("SaasIcon", {
              attrs: { icon: "svgLogoSellsyCloud", width: "96", height: "96" }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }